/**
 * Chart Error State
 * Display friendly error message when chart rendering fails
 */

import React from 'react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/Button'
import { AlertCircle, RotateCw } from 'lucide-react'

interface ChartErrorProps {
  message?: string
  onRetry?: () => void
  width?: number | string
  height?: number
}

export const ChartError: React.FC<ChartErrorProps> = ({
  message = 'Erro ao carregar gráfico',
  onRetry,
  width = '100%',
  height = 400
}) => {
  return (
    <div
      className="flex flex-col items-center justify-center bg-background rounded-lg p-6"
      style={{ width, height }}
    >
      <Alert variant="destructive" className="max-w-md" role="alert">
        <div className="flex flex-col items-center text-center gap-3">
          <AlertCircle className="h-12 w-12" aria-hidden="true" />
          <div>
            <AlertTitle>Erro no Gráfico</AlertTitle>
            <AlertDescription>{message}</AlertDescription>
          </div>
          {onRetry && (
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              className="mt-2"
            >
              <RotateCw className="mr-2 h-4 w-4" />
              Tentar Novamente
            </Button>
          )}
        </div>
      </Alert>
    </div>
  )
}
